var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconComputer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-device 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.83333 6.83325C4.58521 6.83325 2.73333 8.68513 2.73333 10.9333V28.6999C2.73333 29.7503 3.14897 30.7043 3.80905 31.4333H0C0 33.6978 1.83543 35.5332 4.1 35.5332H36.9C39.1646 35.5332 41 33.6978 41 31.4333H37.191C37.851 30.7043 38.2667 29.7503 38.2667 28.6999V10.9333C38.2667 8.68513 36.4148 6.83325 34.1667 6.83325H6.83333ZM6.83333 9.56659H34.1667C34.9389 9.56659 35.5333 10.161 35.5333 10.9333V28.6999C35.5333 29.4721 34.9389 30.0666 34.1667 30.0666H6.83333C6.06113 30.0666 5.46667 29.4721 5.46667 28.6999V10.9333C5.46667 10.161 6.06113 9.56659 6.83333 9.56659Z",
    fill: "#735BF2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComputer);
export default __webpack_public_path__ + "static/media/iconComputer.28af1031840ced85a3e471d6efec5bca.svg";
export { ForwardRef as ReactComponent };